import { render, staticRenderFns } from "./AuthrizedUserSwitch.vue?vue&type=template&id=6536200e&scoped=true&"
import script from "./AuthrizedUserSwitch.vue?vue&type=script&lang=js&"
export * from "./AuthrizedUserSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AuthrizedUserSwitch.vue?vue&type=style&index=0&id=6536200e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536200e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
